import { render, staticRenderFns } from "./PurchaseInvoiceLines.vue?vue&type=template&id=2913429a&scoped=true"
import script from "./PurchaseInvoiceLines.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceLines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2913429a",
  null
  
)

export default component.exports